<template>
  <el-row class="text-align-left body-content" oncontextmenu="return false" onselectstart="return false">
    <el-col :span="24" class="banner" id="banner">
      <div class="banner-image">
        <img src="../assets/OOCL_logo.svg" class="oocl-logo">
        <div class="assessment-intro">
          <div class="assessment-title">{{answerPageTitle}}</div>
          <div class="assessment-wording" v-html="answerPageContent"></div>
        </div>
      </div>
    </el-col>
    <el-col :span="24" class="banner-small" id="bannerSmall">
      <div class="banner-small-height">
        <img src="../assets/OOCL_logo.svg" class="oocl-logo-small">
        <div class="assessment-title-small">{{answerPageTitle}}</div>
      </div>
    </el-col>
    <el-col :xl="3" :lg="4" :md="5" :sm="6">
      <div class="assessment-steps" id="assessmentSteps">
        <el-steps direction="vertical" :active="enabledSection">
          <el-step :title="item.section" v-for="(item,index) in sectionInfo" :key="item.id" v-on:click.native="handleSection(index)" :status="item.status"></el-step>
        </el-steps>
      </div>
    </el-col>
    <el-col :xl="3" :lg="4" :md="5" :sm="6" style="height:10px"></el-col>
    <el-col :xl="21" :lg="20" :md="19" :sm="18">
      <div class="line" id="line"></div>
      <div id="assessmentBody" class="assessment-body" v-if="handleLastSection()">
        <div class="description-main" id="descriptionMain">
          <div class="description-content" id="descriptionContent" v-html="descriptionContent" v-if="userType===StakeholderType&&section.type == null"></div>
          <div class="description-body" id="descriptionBody" v-html="descriptionChoiceTable" v-if="userType===StakeholderType"></div>
        </div>
        <div class="assessment-body-title" id="section_name">{{section.section}}</div>
        <div class="assessment-body-question" v-for="(question, index) in section.questionVoList" :key="question.id">
          <span>{{index+1}}.&nbsp;</span><span class="assessment-body-subject" v-html="question.question"></span>
          <div v-if="question.multiSelect === 0">
            <el-radio-group v-model="selectOption.singleSelect[question.id]">
              <div class="assessment-body-answer" v-for="option in question.optionVoList" :key="option.id">
                <el-radio :label="option.id">{{option.option}}</el-radio>
              </div>
            </el-radio-group>
          </div>
          <div v-else>
            <el-checkbox-group v-model="selectOption.multipleSelect[question.id]" @change="handleCheckboxChange">
              <div class="assessment-body-answer-multiple" v-for="option in question.optionVoList" :key="option.id">
                <el-checkbox :label="option.id">{{option.option}}</el-checkbox>
              </div>
            </el-checkbox-group>
          </div>
        </div>
        <el-button v-show="showButton" @click="clickPreviousBtn" :disabled="active===0">{{btnPreText}}</el-button>
        <el-button v-show="showButton" v-if="userType === StakeholderType && active === sectionInfo.length-1" type="danger"  @click="saveAnswerInfo" :disabled="Object.getOwnPropertyNames(selectOption.singleSelect).length - 1 + multipleSelectedLength < questionLength">{{btnSubmitText}}</el-button>
        <el-button v-show="showButton" type="danger" @click="clickNextBtn" v-else-if="!(Object.getOwnPropertyNames(selectOption.singleSelect).length - 1 + multipleSelectedLength < questionLength)">{{btnNextText}}</el-button>
      </div>
      <!-- Declaration -->
      <div class="assessment-body" v-if="userType===VendorType && active===sectionInfo.length-1">
        <div class="assessment-body-title">
          <el-checkbox v-model="checked">{{declaration}}</el-checkbox>
        </div>
        <div class="assessment-body-question">{{declarationContent}}
          <div style="margin-top: 20px">
            <el-form label-position="left" class="dialog-form">
              <el-form-item :label="signCompany">
              </el-form-item>
              <p>{{companyName}}</p>
              <hr class="underline"/>
            </el-form></div>
        </div>
        <el-button  @click="clickPreviousBtn" :disabled="active===0">{{btnPreText}}</el-button>
        <el-button  v-if="companyName!=''&& checked" type="danger" @click="submitAnswer">{{btnSubmitText}}</el-button>
      </div>
      <!-- new Section -->
      <div class="assessment-body" style="top: 180px" v-if="userType===StakeholderType && section.type===newSectionType">
        <div class="assessment-body-title">{{section.section}}</div>
        <div class="peer-wording" v-html="section.descTop"></div>
        <div class="assessment-body-question">
          <div class="assessment-body-question" v-for="question in section.questionVoList" :key="question.id">
            <div class="assessment-body-subject" v-html="question.question"></div>
            <el-checkbox-group v-model="selectOption.multipleSelect[question.id]" @change="handleCheckboxStatus">
              <div class="assessment-body-answer-multiple" style="display: block;" v-for="option in question.optionVoList" :key="option.id">
                <el-checkbox :disabled="multiCheckboxStatus[option.id]" :label="option.id">
                  <div v-html="option.option"></div>
                </el-checkbox>
              </div>
            </el-checkbox-group>
          </div>
          <div class="peer-tips" v-html="section.descBottom"></div>
        </div>
        <el-button @click="clickPreviousBtn" :disabled="active===0">{{btnPreText}}</el-button>
        <el-button v-if="active === sectionInfo.length-1" type="danger"  @click="saveAnswerInfo" :disabled="nextButtonStatus">{{btnSubmitText}}</el-button>
        <el-button type="danger" @click="clickNextBtn" v-else-if="!nextButtonStatus">{{btnNextText}}</el-button>
      </div>
      <!--Peer Evaluation Section 1-->
      <div class="assessment-body" style="top: 180px" v-if="userType===StakeholderType && section.type===peerSectionType && section.selectCount === 1">
        <div class="assessment-body-title">{{section.section}}</div>
        <div class="peer-wording" v-html="section.descTop"></div>
        <div class="assessment-body-question">
          <el-table :data="section.questionVoList" empty-text="No Data" style="text-align: center;width: 100%;z-index:8;" height="800px" border>
            <el-table-column v-for="(item, index) in section.questionVoList" :fixed="true" v-if="index===0" :key="item.id">
              <template slot-scope="scope" >
                <span v-html="scope.row.question"></span>
              </template>
            </el-table-column>
            <el-table-column header-align="center" v-for="(item, index) in section.questionVoList[0].optionVoList" :label="item.option" :key="index">
              <template slot-scope="scope" style="text-align: center">
              <span>
                <el-radio :name="scope.row.id" v-model="selectOption.singleSelect[scope.row.id]" :label="scope.row.optionVoList[index].id">&nbsp;</el-radio></span>
              </template>
            </el-table-column>
          </el-table>
          <div class="peer-tips" v-html="section.descBottom"></div>
        </div>
        <el-button @click="clickPreviousBtn" :disabled="active===0">{{btnPreText}}</el-button>
        <el-button v-if="active === sectionInfo.length-1" type="danger"  @click="saveAnswerInfo" :disabled="Object.getOwnPropertyNames(selectOption.singleSelect).length - 1 + multipleSelectedLength < questionLength">{{btnSubmitText}}</el-button>
        <el-button type="danger" @click="clickNextBtn" v-else-if="!Object.getOwnPropertyNames(selectOption.singleSelect).length - 1 + multipleSelectedLength < questionLength">{{btnNextText}}</el-button>
      </div>
      <!--Peer Evaluation Section 2-->
      <div class="assessment-body" style="top: 180px" v-if="userType===StakeholderType && section.type===peerSectionType && section.selectCount > 1">
        <div class="assessment-body-title">{{section.section}}</div>
        <div class="peer-wording" v-html="section.descTop"></div>
        <div class="assessment-body-question">
          <el-table :data="section.questionVoList" empty-text="No Data" style="text-align: center;width: 100%;z-index:8;" selection height="670px" border>
            <el-table-column v-for="(item, index) in section.questionVoList" :fixed="true" v-if="index===0" :key="item.id">
              <template slot-scope="scope" >
                <span v-html="scope.row.question"></span>
              </template>
            </el-table-column>
            <el-table-column header-align="center" v-for="(item, index) in section.questionVoList[0].optionVoList" :label="item.option" :key="index">
              <template slot-scope="scope" style="text-align: center;">
                <span>
                  <el-checkbox-group v-model="selectOption.peerSelect[index]" style="margin-top: 10px;">
                    <el-checkbox :disabled="checkboxStatus[scope.row.optionVoList[index].id]" :label="scope.row.id+','+scope.row.optionVoList[index].id">&nbsp;</el-checkbox>
                  </el-checkbox-group>
                </span>
              </template>
            </el-table-column>
          </el-table>
          <div class="peer-tips" v-html="section.descBottom"></div>
        </div>
        <el-button @click="clickPreviousBtn" :disabled="active===0">{{btnPreText}}</el-button>
        <el-button v-if="active === sectionInfo.length-1 && !submitButtonStatus" type="danger"  @click="saveAnswerInfo">{{btnSubmitText}}</el-button>
        <el-button type="danger" @click="clickNextBtn" v-else-if="!submitButtonStatus">{{btnNextText}}</el-button>
      </div>
    </el-col>
    <Footer></Footer>
  </el-row>
</template>

<script>
import Footer from '@/components/Footer.vue';
import { assessmentInfo } from '@/services/answerer/assessment.service';
import { checkAnswerInfo, callSaveAnswerInfo, findAnswerDetailInfo, checkStatus } from '@/services/answerer/answerer.service'
import Constant from '@/common/Constant'
import GetIp from '@/utils/getIPAddress'

export default {
  components: {
    Footer
  },
  data () {
    return {
      companyName: sessionStorage.getItem(Constant.USER_NAME),
      multipleSelectedLength: 0,
      answerPageTitle: '',
      answerPageContent: '',
      selectOption: {
        singleSelect: {},
        multipleSelect: {},
        peerSelect: []
      }, // store the user's selection
      selectedInfo: {}, // store the user's selection from database(DB)
      active: 0,
      assessmentVo: {}, // store the assessment information from DB
      language: '',
      sectionInfo: {}, // store the sections information of assessment
      section: {}, // store the current section's information
      questionLength: '', // mark the question count which user had selected
      userType: '',
      btnNextText: '',
      btnPreText: '',
      enabledSection: 0,
      checked: '',
      submitter: '',
      company: '',
      dialogVisible: false,
      btnSubmitText: '',
      target: '',
      userName: '',
      finishText: '',
      btnCloseText: '',
      titleCompleted: '',
      VendorType: Constant.TYPE_VENDOR,
      StakeholderType: Constant.TYPE_STAKEHOLDER,
      alertSignInformation: '',
      btnOkText: '',
      choiceLanguage: {},
      descriptionChoiceTable: '',
      descriptionContent: '',
      optionInfoList: [],
      peerSectionType: Constant.SECTION_TYPE_PEER_EVALUATION,
      newSectionType: Constant.SECTION_TYPE_LIMITMULTISELECTION,
      submitButtonStatus: true,
      answerQuestionLength: 0,
      checkboxStatus: [],
      peerSection: [],
      limitMultiSelection: [],
      declaration: '',
      multiCheckboxStatus: [],
      declarationContent: '',
      signName: '',
      signCompany: '',
      showButton: false,
      nextButtonStatus: true,
      answererDto: {
        userType: sessionStorage.getItem(Constant.USER_TYPE),
        answerAssessmentId: sessionStorage.getItem(Constant.ANSWER_ASSESSMENT_ID),
        keyCode: sessionStorage.getItem(Constant.ASSESSMENT_KEY_CODE)
      },
      ipAddress: ''
    };
  },
  methods: {
    handleLastSection () {
      if (this.userType === Constant.TYPE_VENDOR) {
        return (this.active !== this.sectionInfo.length - 1);
      } else {
        // stakeholder
        return (this.section.type !== Constant.SECTION_TYPE_PEER_EVALUATION && this.section.type !== this.newSectionType);
      }
    },
    handleSection (index) {
      if (index > this.active) {
        if (index < this.enabledSection) {
          let next = index - this.active;
          for (let j = 0; j < next; j++) {
            this.gotoNextSection();
          }
        }
      } else {
        let pre = this.active - index;
        for (let i = 0; i < pre; i++) {
          this.clickPreviousBtn();
        }
      }
    },
    handleStepStatus () {
      this.sectionInfo.forEach((item, index) => {
        if (index < this.enabledSection) {
          item.status = 'active';
        } else {
          item.status = 'wait';
        }
      });
      this.sectionInfo[this.active].status = 'process';
    },
    clickPreviousBtn () {
      let answerAssessmentDto = {
        userType: this.answererDto.userType,
        answerAssessmentId: this.answererDto.answerAssessmentId,
        keyCode: this.answererDto.keyCode
      };
      new Promise(function (resolve) {
        let result = checkStatus(answerAssessmentDto);
        resolve(result);
      }).then((value) => {
        if (Constant.ANSWER_STATUS_COMPLETED === value.data) {
          this.$router.push({name: 'AssessmentCompleted', params: { userType: this.userType, language: Constant.LANGUAGE_ALL }});
        } else {
          this.active--;
          if (this.active < 0) {
            this.active = 0;
          } else {
            this.questionLength -= this.section.questionVoList.length;
          }
          this.section = this.sectionInfo[this.active];
          this.handleStepStatus();
          document.documentElement.scrollTop = document.getElementsByClassName('assessment-body').offsetTop;
        }
      }).catch(e => {
        this.$router.push({name: 'ErrorPage'});
      })
    },
    saveAnswerInfo () {
      // to note the user's answer datail in order to insert to database
      this.$loading({fullscreen: true});
      let answerDetailList = []; // store the answerDetail list
      if (this.section.type === Constant.SECTION_TYPE_PEER_EVALUATION && this.section.selectCount > 1) {
        this.selectOption.peerSelect.forEach(selection => {
          selection.forEach(item => {
            let itemArray = item.split(',');
            let answerDetail = {
              sectionId: this.section.id,
              questionId: itemArray[0],
              optionId: itemArray[1],
              multiSelect: 2
            };
            answerDetailList.push(answerDetail);
          })
        });
      } else {
        for (let i = 0; i < this.section.questionVoList.length; i++) {
          let question = this.section.questionVoList[i];
          let answerDetail;
          if (question.multiSelect === 0) {
            // single
            answerDetail = {
              questionId: '',
              optionId: '',
              multiSelect: ''
            };
            answerDetail.questionId = question.id;
            answerDetail.optionId = this.selectOption.singleSelect[question.id];
            answerDetail.multiSelect = question.multiSelect;
            answerDetailList.push(answerDetail);
          } else {
            // multiple
            if (this.selectOption.multipleSelect[question.id].length === 0) {
              this.$alert('Please check the uncheck answers.', {
                confirmButtonText: 'OK',
                confirmButtonClass: 'el-button--danger'
              });
              this.$loading({fullscreen: true}).close();
              return false;
            } else {
              for (let i = 0; i < this.selectOption.multipleSelect[question.id].length; i++) {
                answerDetail = {
                  questionId: '',
                  optionId: '',
                  multiSelect: ''
                };
                answerDetail.questionId = question.id;
                answerDetail.optionId = this.selectOption.multipleSelect[question.id][i];
                answerDetail.multiSelect = question.multiSelect;
                answerDetailList.push(answerDetail);
              }
            }
          }
        }
      }
      let answerAssessmentDto = {
        ip: this.ipAddress,
        userType: this.userType,
        questionnaireStatus: Constant.ANSWER_STATUS_INPROGRESS,
        answerAssessmentId: sessionStorage.getItem(Constant.ANSWER_ASSESSMENT_ID),
        answerDetailVoList: answerDetailList,
        language: this.language
      };
      let isFinalSection = this.userType === Constant.TYPE_STAKEHOLDER && this.active === this.sectionInfo.length - 1;
      if (isFinalSection) {
        answerAssessmentDto.questionnaireStatus = Constant.ANSWER_STATUS_COMPLETED;
      }
      callSaveAnswerInfo(answerAssessmentDto).then(value => {
        this.$loading({fullscreen: true}).close();
        if (isFinalSection && value.data === 'OK' && value.code === 'SUCCESS') {
          this.$router.push({name: 'AssessmentCompleted', params: { userType: this.userType, language: this.language }});
        }
      });
      return true;
    },
    clickNextBtn () {
      let answerAssessmentDto = {
        userType: this.answererDto.userType,
        answerAssessmentId: this.answererDto.answerAssessmentId,
        keyCode: this.answererDto.keyCode
      };
      new Promise(function (resolve) {
        let result = checkStatus(answerAssessmentDto);
        resolve(result);
      }).then((value) => {
        if (Constant.ANSWER_STATUS_COMPLETED === value.data) {
          this.$router.push({name: 'AssessmentCompleted', params: { userType: this.userType, language: Constant.LANGUAGE_ALL }});
        } else {
          let flag = this.saveAnswerInfo();
          if (flag) {
            this.gotoNextSection();
            if (this.userType === Constant.TYPE_VENDOR && this.active === this.sectionInfo.length - 1) {
              this.enabledSection += 1;
            }
          }
        }
      }).catch(e => {
        this.$router.push({name: 'ErrorPage'});
      })
    },
    gotoNextSection () {
      // control the display of next section
      if (this.active < this.sectionInfo.length - 1) {
        this.active++;
        this.section = this.sectionInfo[this.active];
        if (this.section.type !== Constant.SECTION_TYPE_PEER_EVALUATION || this.section.selectCount === 1) {
          this.questionLength += this.section.questionVoList.length;
        }
      } else {
        this.section = this.sectionInfo[this.active];
      }
      this.enabledSection = this.section.sequence < this.enabledSection ? this.enabledSection : this.section.sequence;
      this.handleStepStatus();
      document.documentElement.scrollTop = document.getElementsByClassName('assessment-body').offsetTop;
    },
    async initAnswerAssessmentPage () {
      let dataObject = await assessmentInfo(sessionStorage.getItem(Constant.ASSESSMENT_ID), this.language);
      this.assessmentVo = dataObject.data;
      if (this.userType === Constant.TYPE_VENDOR) {
        this.target = Constant.VENDOR_PAGES_TEXT;
      } else {
        this.target = Constant.STAKEHOLDER_PAGES_TEXT;
      }
    },
    async findAnswerDetailInfo () {
      const answerAssessmentId = sessionStorage.getItem(Constant.ANSWER_ASSESSMENT_ID);
      let detailInfo = await findAnswerDetailInfo(answerAssessmentId, this.userType);
      let answeredSectionIdSet = new Set();
      if (detailInfo.data.length > 0) {
        // Restore selected options
        this.selectedInfo = detailInfo.data;
        let radioInfo = {
          singleSelect: {},
          multipleSelect: {},
          peerSelect: []
        };
        this.selectedInfo.forEach(item => {
          answeredSectionIdSet.add(item.sectionId);
          if (item.multiSelect === '0') {
            radioInfo.singleSelect[item.questionId] = item.optionId;
          } else if (item.multiSelect === '1') {
            if (!radioInfo.multipleSelect[item.questionId]) {
              this.$set(radioInfo.multipleSelect, '' + item.questionId, []);
              this.multipleSelectedLength += 1;
            }
            radioInfo.multipleSelect[item.questionId].push(item.optionId);
          } else {
            if (!radioInfo.peerSelect[item.optionSequence - 1]) {
              this.$set(radioInfo.peerSelect, '' + item.optionSequence - 1, []);
            }
            radioInfo.peerSelect[item.optionSequence - 1].push(item.questionId + ',' + item.optionId);
          }
        });
        this.selectOption = radioInfo;
      }
      // add multiple selection array when not exists
      this.sectionInfo.forEach(section => {
        section.questionVoList.forEach(question => {
          if (!this.selectOption.multipleSelect[question.id] && question.multiSelect === 1) {
            this.$set(this.selectOption.multipleSelect, '' + question.id, []);
          }
        });
        if (section.type === Constant.SECTION_TYPE_PEER_EVALUATION && section.selectCount > 1) {
          for (let i = 0; i < section.questionVoList[0].optionVoList.length; i++) {
            if (!this.selectOption.peerSelect['' + i]) {
              this.$set(this.selectOption.peerSelect, '' + i, []);
            }
          }
        }
      });
      // Set enabled section
      this.enabledSection = answeredSectionIdSet.size + 1;
      this.handleStepStatus();
      if (this.limitMultiSelection.length !== 0) {
        this.handleCheckboxStatus();
      }
      this.$loading({fullscreen: true}).close();
    },
    getInitInfo () {
      this.userType = sessionStorage.getItem(Constant.USER_TYPE);
      this.language = sessionStorage.getItem(Constant.LANGUAGE);
      this.userName = sessionStorage.getItem(Constant.USER_NAME);
    },
    getSectionInfo () {
      switch (this.language) {
        case Constant.LANGUAGE_EN:
          this.sectionInfo = this.assessmentVo.sectionEnList;
          this.choiceLanguage = this.$store.state.dictionary[1];
          break;
        case Constant.LANGUAGE_SC:
          this.sectionInfo = this.assessmentVo.sectionScList;
          this.choiceLanguage = this.$store.state.dictionary[2];
          break;
        case Constant.LANGUAGE_TC:
          this.sectionInfo = this.assessmentVo.sectionTcList;
          this.choiceLanguage = this.$store.state.dictionary[3];
          break;
      }
      this.section = this.sectionInfo[0];
      this.questionLength = this.section.questionVoList.length;
      if (this.userType === Constant.TYPE_VENDOR) {
        let declaration = {
          section: this.choiceLanguage.ANSWER_DECLARATION,
          sequence: this.sectionInfo.length + 1,
          questionVoList: []
        };
        this.sectionInfo.push(declaration);
      }
      if (this.userType === Constant.TYPE_STAKEHOLDER) {
        this.initDescriptionContentForStakeholder();
      }
    },
    initLanguageInfo () {
      this.btnNextText = this.choiceLanguage.BUTTON_NEXT;
      this.btnPreText = this.choiceLanguage.BUTTON_PREVIOUS;
      this.btnSubmitText = this.choiceLanguage.BUTTON_SUBMIT;
      this.btnClose = this.choiceLanguage.BUTTON_CLOSE;
      this.titleCompleted = this.choiceLanguage.TITLE_COMPLETED;
      this.btnOkText = this.choiceLanguage.BUTTON_OK;
      if (this.userType === Constant.TYPE_VENDOR) {
        this.alertSignInformation = this.choiceLanguage.ALERT_SIGN_INFORMATION;
        this.answerPageTitle = this.choiceLanguage.WELCOME_TITLE_VENDOR;
        this.answerPageContent = this.replaceAnswererText(this.target, this.choiceLanguage.WELCOME_CONTENT_VENDOR, this.userName);
        this.declaration = this.choiceLanguage.ANSWER_DECLARATION;
        this.declarationContent = this.choiceLanguage.ANSWER_DECLARATION_CONTENT;
        this.signName = this.choiceLanguage.SIGN_NAME;
        this.signCompany = this.choiceLanguage.SIGN_COMPANY;
        this.finishText = this.choiceLanguage.FINISH_TEXT_VENDOR;
      } else {
        this.answerPageTitle = this.choiceLanguage.WELCOME_TITLE_STAKEHOLDER;
        this.answerPageContent = this.replaceAnswererText(this.target, this.choiceLanguage.WELCOME_CONTENT_STAKEHOLDER, this.userName);
        this.finishText = this.choiceLanguage.FINISH_TEXT_STAKEHOLDER;
      }
    },
    submitAnswer () {
      this.dialogVisible = true;
      let answerAssessmentDto = {
        ip: this.ipAddress,
        userType: this.userType,
        answerAssessmentId: sessionStorage.getItem(Constant.ANSWER_ASSESSMENT_ID),
        language: this.language,
        signName: '',
        signCompany: '',
        completed: true
      };
      this.$loading({fullscreen: true});
      callSaveAnswerInfo(answerAssessmentDto);
      this.$loading({fullscreen: true}).close();
      this.$router.push({
        name: 'AssessmentCompleted',
        params: {'userType': this.userType, 'language': this.language}
      });
    },
    closeDialog () {
      this.dialogVisible = false;
    },
    replaceAnswererText (target, info, answererName) {
      info = info.replace(new RegExp(target, 'g'), answererName);
      return info;
    },
    handleCheckboxChange () {
      this.multipleSelectedLength = 0;
      this.sectionInfo.forEach(section => {
        section.questionVoList.forEach(question => {
          if (question.multiSelect === 1 && this.selectOption.multipleSelect[question.id].length > 0) {
            this.multipleSelectedLength += 1;
          }
        });
      });
    },
    initDescriptionContentForStakeholder () {
      this.descriptionContent = this.choiceLanguage.DESCRIPTION_CONTENT;
      this.descriptionChoiceTable = this.choiceLanguage.DESCRIPTION_CHOICE_TABLE;
    },
    initCheckboxStatus () {
      this.sectionInfo.forEach(section => {
        if (section.type === Constant.SECTION_TYPE_PEER_EVALUATION && section.selectCount > 1) {
          this.peerSection = section;
          section.questionVoList.forEach(question => {
            question.optionVoList.forEach(option => {
              this.$set(this.checkboxStatus, '' + option.id, []);
              this.checkboxStatus[option.id] = false;
            });
          });
        }
        if (section.type === Constant.SECTION_TYPE_LIMITMULTISELECTION) {
          this.limitMultiSelection = section;
          this.initMultiCheckboxStatus(section);
        }
      });
    },
    initMultiCheckboxStatus (section) {
      section.questionVoList.forEach(question => {
        question.optionVoList.forEach(option => {
          this.$set(this.multiCheckboxStatus, '' + option.id, []);
          this.multiCheckboxStatus[option.id] = false;
        });
      });
    },
    handleScroll () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      let banner = document.getElementById('banner');
      let bannerSmall = document.getElementById('bannerSmall');
      let assessmentSteps = document.getElementById('assessmentSteps');
      let line = document.getElementById('line');
      let descriptionBody = document.getElementById('descriptionBody');
      let descriptionMain = document.getElementById('descriptionMain');
      if (scrollTop > 180) {
        banner.style.display = 'none';
        bannerSmall.style.display = 'block';
        assessmentSteps.style.top = '80px';
        line.style.top = '80px';
        line.style.height = '730px';
        if (descriptionBody !== null) {
          descriptionMain.style.top = '110px';
        }
      } else {
        banner.style.display = 'block';
        bannerSmall.style.display = 'none';
        assessmentSteps.style.top = '185px';
        line.style.top = '185px';
        line.style.height = '650px';
        if (descriptionBody !== null) {
          descriptionMain.style.top = '185px';
        }
      }
    },
    handleCheckboxStatus () {
      this.handleCheckboxChange();
      let handleStatusFlag = 0;
      this.limitMultiSelection.questionVoList.forEach(question => {
        if (this.selectOption.multipleSelect[question.id].length === this.limitMultiSelection.selectCount) {
          let selectOptions = [];
          question.optionVoList.forEach(option => {
            this.selectOption.multipleSelect[question.id].forEach(selectOption => {
              if (selectOption === option.id) {
                selectOptions.push(option.id);
              } else {
                this.multiCheckboxStatus[option.id] = true;
              }
            });
          });
          selectOptions.forEach(selectOption => {
            this.multiCheckboxStatus[selectOption] = false;
          });
          handleStatusFlag += 1;
        } else {
          question.optionVoList.forEach(option => {
            this.selectOption.multipleSelect[question.id].forEach(selectOption => {
              this.multiCheckboxStatus[option.id] = false;
            });
          });
        }
      });
      this.nextButtonStatus = !(handleStatusFlag === this.limitMultiSelection.questionVoList.length);
    },
    async checkAnswerInfo (params) {
      const answererInfo = await checkAnswerInfo(params);
      if (answererInfo.data.status === Constant.ANSWER_STATUS_COMPLETED) { // no need show assessment if completed
        this.goCompleted();
      }
    },
    goCompleted () {
      this.$router.push({name: 'AssessmentCompleted', params: { userType: this.answererDto.userType, language: Constant.LANGUAGE_ALL }});
    },
    getIP () {
      try {
        GetIp.getUserIP(ip => {
          this.ipAddress = ip;
        });
      } catch (e) {
        this.ipAddress = null;
      }
    }
  },
  mounted () {
    if (sessionStorage.getItem(Constant.USER_NAME) === null) {
      this.$router.go(-1);
      return;
    }
    this.getIP();
    this.checkAnswerInfo(this.answererDto);
    this.$loading({fullscreen: true});
    window.addEventListener('scroll', this.handleScroll);
    this.getInitInfo();
    this.initAnswerAssessmentPage().then(val => {
      this.getSectionInfo();
      this.initLanguageInfo();
      this.initCheckboxStatus();
      this.findAnswerDetailInfo();
      this.showButton = true;
    });
    // set title
    if (this.userType === Constant.TYPE_VENDOR) {
      document.title = 'OOCL Vendor ESG Assessment';
    } else {
      document.title = 'OOCL Stakeholder Engagement Survey';
    }
  },
  computed: {
    peerSelect () {
      return this.selectOption.peerSelect;
    }
  },
  watch: {
    peerSelect (newValue, oldValue) {
      let handleStatusFlag = 0;
      newValue.forEach((item, index) => {
        let optionGroup = [];
        this.peerSection.questionVoList.forEach(question => {
          let optionList = question.optionVoList;
          for (let i = 0; i < optionList.length; i++) {
            if (optionList[i].sequence - 1 === index) {
              optionGroup.push(optionList[i].id);
              break;
            }
          }
        });
        // handle able/enable
        let falseStatusList = [];
        item.forEach(selectOption => {
          // let falseStatusList = [];
          let choiceOption = selectOption.split(',');
          for (let i = 0; i < optionGroup.length; i++) {
            // choiceOption[1] is the optionID of the user's selection
            if (item.length === this.peerSection.selectCount) {
              if (choiceOption[1] === optionGroup[i]) {
                falseStatusList.push(choiceOption[1]);
              }
              this.checkboxStatus[optionGroup[i]] = true;
            } else {
              // all the checkbox status is false
              this.checkboxStatus[optionGroup[i]] = false;
            }
          }
        });
        if (item.length === this.peerSection.selectCount) {
          for (let j = 0; j < falseStatusList.length; j++) {
            this.checkboxStatus[falseStatusList[j]] = false;
          }
          handleStatusFlag += 1;
        }
      });
      this.submitButtonStatus = !(handleStatusFlag === newValue.length);
    }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll);
    this.$loading({fullscreen: true}).close();
  }
};
</script>

<style scoped>
.text-align-left {
  text-align: left;
}

.banner {
  position: fixed;
  background-color: #fff;
  z-index: 9;
  height: 215px;
}

.banner-image {
  background-image: url("../assets/assessment_banner.jpg");
  height: 185px;
  background-repeat: no-repeat;
  background-position: center;
}

.banner-small {
  position: fixed;
  height: 110px;
  background-color: #fff;
  display: none;
  z-index: 9;
}

.banner-small-height {
  height: 80px;
  box-shadow: 0 0 18px 3px rgba(26, 102, 255, 0.1);
}

.oocl-logo {
  height: 50px;
  padding-left: 48px;
  padding-top: 50px;
}

.oocl-logo-small {
  height: 50px;
  padding-left: 48px;
  position: relative;
  top: 15px;
}

.assessment-intro {
  display: inline-block;
  color: #fff;
  margin: 0 0 0 88px;
  position: relative;
  top: 35px;
}

.assessment-body {
  padding: 35px 40px 90px 65px;
  position: relative;
  top: 180px;
}

@media screen and (max-width: 785px) {
  .assessment-body {
    padding: 35px 40px 90px 0;
    position: absolute;
    left:20px;
    top: 180px;
  }

  .assessment-steps {
    display: none;
  }

  .line {
    display: none;
  }
}

.assessment-body-title {
  color: #2d2d2d;
  font-weight: bold;
  font-size: 28px;
  margin-bottom: 20px;
}

.assessment-title {
  font-size: 42px;
  font-weight: bold;
}

.assessment-title-small {
  display: inline-block;
  font-size: 32px;
  font-weight: bold;
  padding-left: 85px;
}

.assessment-wording {
  font-size: 16px;
}

.assessment-steps {
  height: 470px;
  margin: 35px 0 0 30px;
  position: fixed;
  top: 185px;
}

.line {
  width: 1px;
  height: 650px;
  background-color: #e6e6e6;
  /*margin: 30px 30px 0 15px;*/
  position: fixed;
  top: 185px;
  margin-left: 40px;
}

.description-main {
  width: 100%;
  position: -webkit-sticky;
  position: sticky;
  background-color: #fff;
  z-index: 9;
  top: 185px;
}

.description-content {
  width: 100%;
  /*position: -webkit-sticky;*/
  /*position: sticky;*/
  /*background-color: #fff;*/
  /*z-index: 9;*/
  /*top: 185px;*/
}

.description-body{
  position: -webkit-sticky;
  position: sticky;
  background-color: #fff;
  z-index: 9;
  box-shadow: 0 0 18px 3px rgba(26, 102, 255, 0.1);
  /*top: 255px;*/
  padding: 15px 20px;
}

.assessment-body-question{
  margin-bottom: 25px;
  margin-left: 25px;
}

.assessment-body-subject{
  color: #000;
  line-height: 20px;
  margin-bottom: 15px;
}

.assessment-body-answer {
  display: inline-block;
  line-height: 30px;
  padding-right: 40px;
  min-width: 100px;
}

.assessment-body-answer-multiple {
  display: inline-block;
  line-height: 30px;
  padding-right: 40px;
  min-width: 250px;
}

.assessment-body .el-button{
  width: 120px;
  height: 40px;
  margin-right: 30px;
  margin-left: 200px;
  margin-top: 20px;
  font-size: 16px;
}

/* RWD Support */
@media screen and (max-width: 1200px){
  .assessment-title {
    font-size: 36px;
  }

  .assessment-steps{
    margin: 55px 40px;
  }
}

@media screen and (max-height: 900px) {
  .assessment-steps {
    height: 400px;
  }
}

@media screen and (max-height: 800px) {
  .assessment-steps {
    height: 320px;
  }
}

/* Peer Evaluation*/
>>>.table-icon{
  color: #9b9b9b;
  cursor: pointer;
  font-size: 16px;
}

>>>.table-icon-selected{
  color: #2d92f7;
  font-size: 16px;
  cursor: pointer;
}

>>>.assessment-body-title .el-checkbox__label{
  color: #2d2d2d;
  font-weight: bold;
  font-size: 28px;
  margin-bottom: 20px;
}

.peer-wording{
  margin-bottom: 10px;
}

.peer-tips{
  font-size: 14px;
  line-height: 18px;
  color: #666;
  margin-top: 8px;
  margin-bottom: 25px;
}

.peer-tips i{
  color:#2b2b2b;
}

/*rewrite element ui style */
>>>.el-button {
  border-color: #D63246;
  color: #D63246;
}

>>>.el-button:hover {
  border-color: #D63246;
  background-color: #f4dbdb;
  color: #D63246;
}

>>>.el-button:focus {
  border-color: #D63246;
  background-color: #f4dbdb;
  color: #D63246;
}

/*>>>.el-button--primary {*/
  /*color: #fff;*/
  /*background-color: #D63246!important;*/
  /*border-color: #D63246!important;*/
  /*color: #fff!important;*/
/*}*/

/*>>>.el-button--primary:hover {*/
  /*background-color: #bf2134!important;*/
  /*border-color: #bf2134!important;*/
  /*color: #fff!important;*/
/*}*/

/*>>>.el-button--primary:focus {*/
  /*background-color: #bf2134!important;*/
  /*border-color: #bf2134!important;*/
  /*color: #fff!important;*/
/*}*/

>>>.el-button--danger {
  background-color: #D63246;
  border-color: #D63246;
  color: #fff;
}

>>>.el-button--danger:hover {
  background-color: #bf2134;
  border-color: #bf2134;
  color: #fff;
}

>>>.el-button--danger:focus {
  background-color: #bf2134;
  border-color: #bf2134;
  color: #fff;
}

>>>.el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover {
  color: #c0c4cc;
  cursor: not-allowed;
  background-image: none;
  background-color: #fff;
  border-color: #ebeef5;
}

>>>.el-button--danger.is-disabled, .el-button--danger.is-disabled:active, .el-button--danger.is-disabled:focus, .el-button--danger.is-disabled:hover {
  color: #fff;
  background-color: #fab6b6!important;
  border-color: #fab6b6!important;
}

>>>.el-step__icon {
  background-color: #9b9b9b;
}

>>>.el-step__head.is-wait {
  border-color: #9b9b9b;
}

>>>.el-step__title.is-wait {
  color: #9b9b9b;
}

>>>.el-step__head.is-finish {
  color: #ffffff;
  border-color: #d63246;
  cursor: pointer;
}

>>>.el-step__title.is-finish {
  color: #d63246;
  cursor: pointer;
}

>>>.el-step__title.is-finish:hover {
  font-weight: bold;
}

>>>.el-step__head.is-finish .el-step__line {
  background-color: #d63246;
}

>>>.el-step__head.is-process {
  color: #ffffff;
  border-color: #d63246;
}

>>>.el-step__head.is-finish .el-step__icon {
  background-color: #d63246;
}

>>>.el-step__head.is-process .el-step__icon {
  background-color: #d63246;
}

>>>.el-step__title.is-process {
  color: #d63246;
}

>>>.el-radio__inner {
  border: 1px solid #9b9b9b;
}

>>>.el-checkbox__inner {
  border: 1px solid #9b9b9b;
}

>>>.el-table th>.cell{
  font-weight: normal;
  color: #000;
}

>>>.el-radio__input.is-checked .el-radio__inner {
  border-color: #2D92F7;
  background: #2D92F7;
}

>>>.el-radio__input.is-checked+.el-radio__label {
  color: #2D92F7;
}

>>>.el-step__descrption .is-process {
  border: 0px;
}

>>>.el-checkbox__input {
  vertical-align: top;
}

>>>.el-checkbox__label {
  vertical-align: top;
  margin-top: -3px;
  margin-bottom: 5px;
}

>>>.el-step__description.is-process {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 2px solid;
  border-color: #d63246;
  background-color: #fff;
  padding-right: 0;
  position: relative;
  right: 39px;
  margin-top: -5px;
}

>>>.el-step.is-vertical .el-step__title {
  max-width: 190px;
  line-height: 20px;
  float: left;
}

@media screen and (max-width: 1410px) {
  .el-step.is-vertical .el-step__title {
    max-width: 160px;
  }
}

@media screen and (max-width: 1300px) {
  .el-step.is-vertical .el-step__title {
    max-width: 140px;
  }
}

@media screen and (max-height: 900px) {
  .assessment-steps{
    height: 400px;
  }
}

@media screen and (max-height: 800px) {
  .assessment-steps {
    height: 320px;
  }
}

>>>.el-step__head.is-active {
  color: #ffffff;
  border-color: #d63246;
}

>>>.el-step__head.is-active .el-step__icon {
  background-color: #d63246;
}

>>>.el-step__title.is-active {
  color: #d63246;
}

>>>.el-step__description.is-active {
  width: 30px;
  border-radius: 50%;
  background-color: #fff;
  padding-right: 0;
  margin-top: -37px;
  position: relative;
  right: 39px;
}

>>>.el-step__title.is-active:hover {
  font-weight: bold;
}

>>>a{
  color: #5e89ed;
}
>>>.el-button--primary {
  color: #fff;
  background-color: #D63246!important;
  border-color: #D63246!important;
  color: #fff!important;
}

>>>.el-button--primary:hover {
  background-color: #bf2134!important;
  border-color: #bf2134!important;
  color: #fff!important;
}

>>>.el-button--primary:focus {
  background-color: #bf2134!important;
  border-color: #bf2134!important;
  color: #fff!important;
}

.body-content {
-moz-user-select: none;
}
.underline{
  width: 200px;
  position: absolute;
}

</style>
<style>
  .el-input{
    margin-top: 0;
    width: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/AnswerAssessment.vue